import { render, staticRenderFns } from "./commonNews.vue?vue&type=template&id=62626a3a&scoped=true"
import script from "./commonNews.vue?vue&type=script&lang=js"
export * from "./commonNews.vue?vue&type=script&lang=js"
import style0 from "./commonNews.vue?vue&type=style&index=0&id=62626a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62626a3a",
  null
  
)

export default component.exports